module.exports = __webpack_public_path__ + "img/gtfy.3039e2ff.png";